
























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product } from '@/store/modules/lib';

@Component
export default class CharacterList extends Vue {

  @Prop({ type: Array, default: [] }) protected characters!: [];

}

